import {FMCSAView} from "@src/pages/settings/integration-view";
import {createFileRoute, useMatches, useParams} from "@tanstack/react-router";
import {useSingleIntegration} from "@zeg/instant/w/useIntegrations";
import {TIntegration, TProfile} from "@zeg/instant/types";
import {intConfig} from "@zeg/shared/intConfig";

export const Route = createFileRoute(
  "/_auth/_settings-layout/$workspaceSlug/settings/integrations/fmcsa"
)({component: RouteComponent});

function RouteComponent() {
  const accumulatedContext = useMatches({
    select: (matches) => matches[matches.length - 1].context,
  });
  const {workspaceSlug} = useParams({
    from: "/_auth/_settings-layout/$workspaceSlug/settings/integrations/fmcsa",
  });
  const fmcsaSlug = intConfig.fmcsa.slug;
  const activeProfile = accumulatedContext.auth.profiles.find(
    (profile: TProfile) => {
      const profileWorkspaceSlug = profile.$workspace?.slug;
      return profileWorkspaceSlug === workspaceSlug;
    }
  );
  const profileId = activeProfile?.id;
  const {data, isLoading, error} = useSingleIntegration(
    profileId as string,
    fmcsaSlug
  );

  // Safely access integration based on potential data shapes
  const integration =
    data && "profiles" in data
      ? (data.profiles?.[0]?.integrations?.[0] as TIntegration)
      : undefined; // If data has no 'profiles' key, integration is undefined

  return (
    <FMCSAView
      isLoading={isLoading}
      error={error as Error}
      integration={integration}
      profile={activeProfile}
    />
  );
}
